/**
 * Authenticated GET helper for back-office screens.
 *
 * The storefront and the back-office share several endpoints. Those endpoints hide
 * inactive rows by default and only reveal them when the caller is a signed-in
 * admin/warehouse/sales user AND passes includeInactive=true. The role is read from
 * the JWT on the server, so the flag alone cannot expose hidden data.
 *
 * Use this from admin screens that are plain functions (not React components) or that
 * do not already have `authFetch` from AuthContext in scope.
 */
export const adminGet = (url) => {
  const token = localStorage.getItem("auth_token");
  const separator = url.includes("?") ? "&" : "?";

  return fetch(`${url}${separator}includeInactive=true`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "include",
  });
};

export default adminGet;
